import { cn } from '@/components/ui/cn'
import { SenseGlossLine } from '@/components/vocabulary/SenseGlossLine'

interface MultipleChoiceQuestionProps {
  questionText: string
  senseGloss?: string
  options: string[]
  selected?: string
  onSelect: (option: string) => void
  disabled?: boolean
}

export function MultipleChoiceQuestion({
  questionText,
  senseGloss,
  options,
  selected,
  onSelect,
  disabled = false,
}: MultipleChoiceQuestionProps) {
  return (
    <div className="space-y-4">
      <div>
        <h2 className="text-lg font-semibold leading-snug text-foreground sm:text-2xl">{questionText}</h2>
        <SenseGlossLine gloss={senseGloss} />
      </div>
      <div className="grid gap-2">
        {options.map((option, index) => (
          <button
            key={option}
            type="button"
            disabled={disabled}
            onClick={() => onSelect(option)}
            className={cn(
              'flex min-h-12 w-full items-center gap-3 rounded-xl border px-4 py-3.5 text-left text-sm transition-colors',
              selected === option
                ? 'border-primary bg-primary/10 text-foreground ring-1 ring-primary/30'
                : 'border-border bg-card text-foreground hover:border-primary/40 hover:bg-secondary/60'
            )}
          >
            <span
              className={cn(
                'flex h-7 w-7 shrink-0 items-center justify-center rounded-md text-xs font-semibold',
                selected === option
                  ? 'bg-primary text-primary-foreground'
                  : 'bg-secondary text-muted-foreground'
              )}
            >
              {String.fromCharCode(65 + index)}
            </span>
            <span className="min-w-0 break-words">{option}</span>
          </button>
        ))}
      </div>
    </div>
  )
}
